// import useTiltEffect from "./useTiltEffect";
import { useState } from "react";

function Figure(props) {
  // Настройки
  const power = 0.02; // Степень влияния расстояния
  const intensity = -3000 // Общая сила эффекта

  const dx = props.position.x - props.x;
  const distanceX = Math.abs(dx);
  const maxDistanceX = window.innerWidth / 1;
  const normalizedDistanceX = Math.min(distanceX / maxDistanceX, 1);
  const coeffX = 1 - Math.pow(normalizedDistanceX, power);
  const parallaxX = (dx / maxDistanceX) * coeffX * intensity;

  const dy = props.position.y - props.y;
  const distanceY = Math.abs(dy);
  const maxDistanceY = window.innerWidth / 1;
  const normalizedDistanceY = Math.min(distanceY / maxDistanceY, 1);
  const coeffY = 1 - Math.pow(normalizedDistanceY, power);
  const parallaxY = (dy / maxDistanceY) * coeffY * intensity;
  //style
  const style = {
    transform: `translateX(${parallaxX}px) translateY(${
      parallaxY
    }px)`,
    transition: "translateY .5s;",
  };
  return (
    <div className="Component">
      <img
        id={props._id}
        className="figure"
        src={props.img}
        style={style}
      />
    </div>
  );
}
export default Figure;
